// EPP Shop Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  console.log('EPP Shop Theme Loaded');

  // Initialize cart drawer
  initCartDrawer();

  // Initialize cart functionality
  initCart();

  // Initialize product thumbnails
  initProductThumbnails();

  // Initialize product form AJAX
  initProductFormAjax();

  // Initialize hero carousel
  initHeroCarousel();

  // Initialize category carousel
  initCategoryCarousel();

  // Initialize products carousel
  initProductsCarousel();

  // Initialize product quick add buttons
  initProductQuickAdd();

  // Initialize mobile menu
  initMobileMenu();

  // Initialize bottom nav
  initBottomNav();

  // Initialize collection filters
  initCollectionFilters();

  // Initialize collection quick add buttons
  initCollectionQuickAdd();

  // Initialize product page features
  initProductQuantity();
  initProductGallery();
  initProductTabs();
});

// Cart functionality
function initCart() {
  const cartLinks = document.querySelectorAll('.cart-link');

  cartLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Add any custom cart interactions here
    });
  });
}

// Product image thumbnails
function initProductThumbnails() {
  const thumbnails = document.querySelectorAll('.product-thumbnails img');
  const mainImage = document.querySelector('.product-image-main');

  if (!mainImage) return;

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const newSrc = this.src.replace('_100x', '_800x');
      mainImage.src = newSrc;

      // Remove active class from all thumbnails
      thumbnails.forEach(t => t.style.borderColor = 'transparent');
      // Add active class to clicked thumbnail
      this.style.borderColor = '#000';
    });
  });
}

// ========================================
// CART DRAWER FUNCTIONALITY
// ========================================

function initCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartIcon = document.getElementById('cart-icon');
  const cartClose = document.getElementById('cart-drawer-close');
  const cartOverlay = document.getElementById('cart-drawer-overlay');

  if (!cartDrawer) return;

  // Open cart drawer
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Close cart drawer
  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  // Quantity buttons
  initQuantityButtons();

  // Remove buttons
  initRemoveButtons();
}

function openCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function initQuantityButtons() {
  // Plus buttons
  document.querySelectorAll('.quantity-plus').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      const input = document.querySelector(`.quantity-input[data-key="${key}"]`);
      const newQty = parseInt(input.value) + 1;
      updateCartItem(key, newQty);
    });
  });

  // Minus buttons
  document.querySelectorAll('.quantity-minus').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      const input = document.querySelector(`.quantity-input[data-key="${key}"]`);
      const newQty = Math.max(0, parseInt(input.value) - 1);
      updateCartItem(key, newQty);
    });
  });

  // Input change
  document.querySelectorAll('.quantity-input').forEach(input => {
    input.addEventListener('change', function() {
      const key = this.dataset.key;
      const newQty = Math.max(0, parseInt(this.value) || 0);
      updateCartItem(key, newQty);
    });
  });
}

function initRemoveButtons() {
  document.querySelectorAll('.cart-drawer-item-remove').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      updateCartItem(key, 0);
    });
  });
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: key,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    refreshCartDrawer(cart);
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

function refreshCartDrawer(cart) {
  // Update cart count
  const cartCount = document.getElementById('cart-count');
  if (cartCount) {
    cartCount.textContent = cart.item_count;
  }

  // Update cart drawer content
  const cartDrawerItems = document.getElementById('cart-drawer-items');
  const cartDrawerTotal = document.getElementById('cart-drawer-total');

  if (cart.item_count === 0) {
    // Show empty cart message
    cartDrawerItems.innerHTML = `
      <div class="cart-drawer-empty">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M9 2L7 6M17 2l2 4M1 6h22M3 6l2 14h14l2-14"/>
        </svg>
        <p>Tu carrito está vacío</p>
        <a href="/collections/all" class="btn">Explorar Productos</a>
      </div>
    `;

    // Hide footer
    const footer = document.querySelector('.cart-drawer-footer');
    if (footer) footer.style.display = 'none';
  } else {
    // Build cart items HTML
    let itemsHTML = '';
    cart.items.forEach(item => {
      const variantTitle = (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null') ?
        `<p class="cart-drawer-item-variant">${item.variant_title}</p>` : '';

      itemsHTML += `
        <div class="cart-drawer-item" data-key="${item.key}">
          <div class="cart-drawer-item-image">
            ${(item.image && item.image !== 'null') ? `<img src="${item.image}" alt="${item.title || ''}">` : ''}
          </div>
          <div class="cart-drawer-item-details">
            <h4>${item.product_title}</h4>
            ${variantTitle}
            <p class="cart-drawer-item-price">${formatMoney(item.price)}</p>
            <div class="cart-drawer-item-quantity">
              <button class="quantity-btn quantity-minus" data-key="${item.key}">-</button>
              <input type="number" value="${item.quantity}" min="0" class="quantity-input" data-key="${item.key}">
              <button class="quantity-btn quantity-plus" data-key="${item.key}">+</button>
            </div>
          </div>
          <div class="cart-drawer-item-total">
            <p>${formatMoney(item.line_price)}</p>
            <button class="cart-drawer-item-remove" data-key="${item.key}">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      `;
    });

    cartDrawerItems.innerHTML = itemsHTML;

    // Update total
    if (cartDrawerTotal) {
      cartDrawerTotal.textContent = formatMoney(cart.total_price);
    }

    // Show footer
    const footer = document.querySelector('.cart-drawer-footer');
    if (footer) footer.style.display = 'block';

    // Reinitialize event listeners
    initQuantityButtons();
    initRemoveButtons();
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

// Add to cart with AJAX (optional enhancement)
function addToCart(variantId, quantity = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    // Update cart count and open drawer
    updateCartCount();
    openCartDrawer();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });
}

// Update cart count and refresh drawer
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update header cart count
      const cartCount = document.getElementById('cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
      // Update bottom nav cart count
      const bottomCartCount = document.getElementById('bottom-cart-count');
      if (bottomCartCount) {
        bottomCartCount.textContent = cart.item_count;
      }
      // Also refresh the drawer content
      refreshCartDrawer(cart);
    });
}

// ========================================
// PRODUCT FORM AJAX
// ========================================

function initProductFormAjax() {
  const productForm = document.querySelector('.product-form-ajax');

  if (!productForm) return;

  productForm.addEventListener('submit', function(e) {
    e.preventDefault();

    const formData = new FormData(this);
    const variantId = formData.get('id');
    const button = this.querySelector('button[type="submit"]');
    const buttonText = button.textContent;

    // Disable button and show loading state
    button.disabled = true;
    button.textContent = 'Agregando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Show success
      button.textContent = '¡Agregado!';

      // Update cart count
      updateCartCount();

      // Open cart drawer
      setTimeout(() => {
        openCartDrawer();
        button.disabled = false;
        button.textContent = buttonText;
      }, 500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.disabled = false;
      button.textContent = 'Error - Intenta de nuevo';
      setTimeout(() => {
        button.textContent = buttonText;
      }, 2000);
    });
  });
}

// ========================================
// HERO CAROUSEL
// ========================================

function initHeroCarousel() {
  const carousel = document.getElementById('hero-carousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.hero-slide');
  const dots = carousel.querySelectorAll('.hero-dot');
  const prevBtn = document.getElementById('hero-prev');
  const nextBtn = document.getElementById('hero-next');

  if (slides.length <= 1) return;

  let currentSlide = 0;
  let autoplayInterval;

  function goToSlide(index) {
    // Remove active class from all slides and dots
    slides.forEach(slide => slide.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));

    // Add active class to current slide and dot
    slides[index].classList.add('active');
    if (dots[index]) {
      dots[index].classList.add('active');
    }

    currentSlide = index;
  }

  function nextSlide() {
    let next = currentSlide + 1;
    if (next >= slides.length) {
      next = 0;
    }
    goToSlide(next);
  }

  function prevSlide() {
    let prev = currentSlide - 1;
    if (prev < 0) {
      prev = slides.length - 1;
    }
    goToSlide(prev);
  }

  function startAutoplay() {
    autoplayInterval = setInterval(nextSlide, 5000);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  // Navigation buttons
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      stopAutoplay();
      nextSlide();
      startAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      stopAutoplay();
      prevSlide();
      startAutoplay();
    });
  }

  // Dots navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      stopAutoplay();
      goToSlide(index);
      startAutoplay();
    });
  });

  // Pause on hover
  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);

  // Start autoplay
  startAutoplay();

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      stopAutoplay();
      prevSlide();
      startAutoplay();
    } else if (e.key === 'ArrowRight') {
      stopAutoplay();
      nextSlide();
      startAutoplay();
    }
  });
}

// ========================================
// CATEGORY CAROUSEL
// ========================================

function initCategoryCarousel() {
  const carousel = document.getElementById('category-carousel');
  if (!carousel) return;

  const track = carousel.querySelector('.category-carousel-track');
  const cards = carousel.querySelectorAll('.category-card');
  const prevBtn = document.getElementById('category-prev');
  const nextBtn = document.getElementById('category-next');

  if (!track || cards.length === 0) return;

  let currentIndex = 0;
  const cardWidth = 280; // Width of card
  const gap = 25; // Gap between cards
  const scrollAmount = cardWidth + gap;

  // Calculate how many cards are visible
  function getVisibleCards() {
    const carouselWidth = carousel.offsetWidth;
    return Math.floor(carouselWidth / (cardWidth + gap));
  }

  function updateCarousel() {
    const offset = -currentIndex * scrollAmount;
    track.style.transform = `translateX(${offset}px)`;
    updateButtons();
  }

  function updateButtons() {
    const visibleCards = getVisibleCards();
    const maxIndex = Math.max(0, cards.length - visibleCards);

    if (prevBtn) {
      prevBtn.disabled = currentIndex === 0;
    }

    if (nextBtn) {
      nextBtn.disabled = currentIndex >= maxIndex;
    }
  }

  function scrollNext() {
    const visibleCards = getVisibleCards();
    const maxIndex = Math.max(0, cards.length - visibleCards);

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  }

  function scrollPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }

  // Event listeners
  if (nextBtn) {
    nextBtn.addEventListener('click', scrollNext);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', scrollPrev);
  }

  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      currentIndex = 0;
      updateCarousel();
    }, 250);
  });

  // Touch/swipe support
  let startX = 0;
  let isDragging = false;

  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  track.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
  });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;

    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        scrollNext();
      } else {
        scrollPrev();
      }
    }

    isDragging = false;
  });

  // Initial update
  updateCarousel();
}

// ========================================
// PRODUCTS CAROUSEL
// ========================================

function initProductsCarousel() {
  const carousel = document.getElementById('products-carousel');
  if (!carousel) return;

  const track = carousel.querySelector('.products-fullwidth-track');
  const cards = carousel.querySelectorAll('.product-card-fullwidth');
  const prevBtn = document.getElementById('products-prev');
  const nextBtn = document.getElementById('products-next');

  if (!track || cards.length === 0) return;

  let currentIndex = 0;
  const cardWidth = 280;
  const gap = 20;
  const scrollAmount = cardWidth + gap;

  function getVisibleCards() {
    const carouselWidth = carousel.offsetWidth;
    return Math.floor(carouselWidth / (cardWidth + gap));
  }

  function updateCarousel() {
    const offset = -currentIndex * scrollAmount;
    track.style.transform = `translateX(${offset}px)`;
    updateButtons();
  }

  function updateButtons() {
    const visibleCards = getVisibleCards();
    const maxIndex = Math.max(0, cards.length - visibleCards);

    if (prevBtn) {
      prevBtn.disabled = currentIndex === 0;
    }

    if (nextBtn) {
      nextBtn.disabled = currentIndex >= maxIndex;
    }
  }

  function scrollNext() {
    const visibleCards = getVisibleCards();
    const maxIndex = Math.max(0, cards.length - visibleCards);

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  }

  function scrollPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', scrollNext);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', scrollPrev);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      currentIndex = 0;
      updateCarousel();
    }, 250);
  });

  // Touch/swipe support
  let startX = 0;
  let isDragging = false;

  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  track.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
  });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;

    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        scrollNext();
      } else {
        scrollPrev();
      }
    }

    isDragging = false;
  });

  updateCarousel();
}

// ========================================
// PRODUCT QUICK ADD
// ========================================

function initProductQuickAdd() {
  const quickAddButtons = document.querySelectorAll('.product-card-fullwidth-btn');

  quickAddButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const productId = this.dataset.productId;
      if (!productId) return;

      const buttonText = this.textContent;
      this.disabled = true;
      this.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        this.textContent = '¡Agregado!';
        updateCartCount();

        setTimeout(() => {
          openCartDrawer();
          this.disabled = false;
          this.textContent = buttonText;
        }, 500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.disabled = false;
        this.textContent = 'Error';
        setTimeout(() => {
          this.textContent = buttonText;
        }, 2000);
      });
    });
  });
}

// ========================================
// MOBILE SIDEBAR
// ========================================

function initMobileMenu() {
  const menuBtn = document.getElementById('mobile-menu-btn');
  const sidebar = document.getElementById('mobile-sidebar');
  const overlay = document.getElementById('mobile-sidebar-overlay');
  const closeBtn = document.getElementById('mobile-sidebar-close');

  if (!menuBtn || !sidebar) return;

  function openSidebar() {
    sidebar.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    sidebar.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  menuBtn.addEventListener('click', openSidebar);

  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);

  // Close on nav link click
  const navLinks = sidebar.querySelectorAll('.mobile-nav-item');
  navLinks.forEach(link => {
    link.addEventListener('click', closeSidebar);
  });

  // Close on escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSidebar();
  });
}

// Bottom nav cart button
function initBottomNav() {
  const cartBtn = document.getElementById('bottom-nav-cart');
  if (cartBtn) {
    cartBtn.addEventListener('click', function() {
      openCartDrawer();
    });
  }
}

// ========================================
// COLLECTION FILTERS
// ========================================

function initCollectionFilters() {
  const filterToggle = document.getElementById('filter-toggle');
  const sidebar = document.getElementById('collection-sidebar');
  const sidebarClose = document.getElementById('sidebar-close');

  if (!filterToggle || !sidebar) return;

  // Toggle sidebar
  filterToggle.addEventListener('click', () => {
    sidebar.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  if (sidebarClose) {
    sidebarClose.addEventListener('click', () => {
      sidebar.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  sidebar.addEventListener('click', (e) => {
    if (e.target === sidebar) {
      sidebar.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  // View toggle
  const viewButtons = document.querySelectorAll('.view-btn');
  const productsGrid = document.getElementById('products-grid');

  viewButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      viewButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const view = this.dataset.view;
      if (view === 'list') {
        productsGrid.style.gridTemplateColumns = '1fr';
      } else {
        productsGrid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(260px, 1fr))';
      }
    });
  });

  // ---- FILTER GROUP TOGGLES ----
  document.querySelectorAll('.filter-group-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      toggle.closest('.filter-group').classList.toggle('is-collapsed');
    });
  });

  // ---- FILTERING LOGIC ----

  const allCards = Array.from(document.querySelectorAll('.product-card-collection'));
  if (allCards.length === 0) return;

  // Build talla filter dynamically from product data
  buildTallaFilter(allCards);

  const applyBtn = document.getElementById('btn-apply-filters');
  const clearBtn = document.getElementById('btn-clear-filters');

  if (applyBtn) applyBtn.addEventListener('click', () => {
    applyFilters(allCards);
    // Close sidebar on mobile after applying
    if (window.innerWidth < 768) {
      sidebar.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  if (clearBtn) clearBtn.addEventListener('click', () => clearFilters(allCards));
}

function buildTallaFilter(cards) {
  const tallaGroup = document.getElementById('filter-group-talla');
  const tallaOptions = document.getElementById('filter-tallas-options');
  if (!tallaGroup || !tallaOptions) return;

  // Collect all unique tallas from products
  const tallasSet = new Set();
  cards.forEach(card => {
    const raw = card.dataset.tallas || '';
    raw.split('|').forEach(t => {
      const v = t.trim();
      if (v) tallasSet.add(v);
    });
  });

  if (tallasSet.size === 0) return;

  // Solo tallas numéricas enteras (calzado/ropa), excluir valores con unidades como "11 mm"
  const filtered = Array.from(tallasSet).filter(t => /^\d+$/.test(t.trim()));

  const sorted = filtered.sort((a, b) => parseInt(a) - parseInt(b));

  tallaOptions.innerHTML = sorted.map(t => `
    <label class="filter-option">
      <input type="checkbox" name="talla" value="${t}">
      <span>${t}</span>
    </label>
  `).join('');

  tallaGroup.style.display = 'block';

  // Activar toggle en el grupo de talla
  const tallaToggle = tallaGroup.querySelector('.filter-group-toggle');
  if (tallaToggle) {
    tallaToggle.addEventListener('click', () => {
      tallaGroup.classList.toggle('is-collapsed');
    });
  }
}

function applyFilters(cards) {
  // Collect active price filters
  const checkedPrices = Array.from(document.querySelectorAll('input[name="price"]:checked')).map(i => i.value);
  // Collect active availability filters
  const checkedAvail = Array.from(document.querySelectorAll('input[name="availability"]:checked')).map(i => i.value);
  // Collect active talla filters
  const checkedTallas = Array.from(document.querySelectorAll('input[name="talla"]:checked')).map(i => i.value);

  const hasFilters = checkedPrices.length || checkedAvail.length || checkedTallas.length;
  const clearBtn = document.getElementById('btn-clear-filters');
  if (clearBtn) clearBtn.style.display = hasFilters ? 'block' : 'none';

  let visibleCount = 0;

  cards.forEach(card => {
    const price = parseInt(card.dataset.price || '0');
    const available = card.dataset.available === 'true';
    const tallas = (card.dataset.tallas || '').split('|').map(t => t.trim()).filter(Boolean);

    let show = true;

    // Price filter
    if (checkedPrices.length) {
      const matchesPrice = checkedPrices.some(range => {
        if (range === '50000+') return price >= 5000000; // cents
        const [min, max] = range.split('-').map(v => parseInt(v) * 100);
        return price >= min && price <= max;
      });
      if (!matchesPrice) show = false;
    }

    // Availability filter
    if (show && checkedAvail.length) {
      const matchesAvail = checkedAvail.some(v => {
        if (v === 'in-stock') return available;
        if (v === 'out-of-stock') return !available;
        return true;
      });
      if (!matchesAvail) show = false;
    }

    // Talla filter
    if (show && checkedTallas.length) {
      const matchesTalla = checkedTallas.some(t => tallas.includes(t));
      if (!matchesTalla) show = false;
    }

    card.style.display = show ? '' : 'none';
    if (show) visibleCount++;
  });

  // Update results count
  const resultsCount = document.querySelector('.results-count');
  if (resultsCount) {
    resultsCount.textContent = visibleCount + ' producto' + (visibleCount !== 1 ? 's' : '');
  }

  // Show empty state if needed
  const grid = document.getElementById('products-grid');
  let emptyMsg = grid && grid.querySelector('.filter-empty-msg');
  if (visibleCount === 0) {
    if (!emptyMsg && grid) {
      emptyMsg = document.createElement('div');
      emptyMsg.className = 'filter-empty-msg empty-collection';
      emptyMsg.innerHTML = '<h3>Sin resultados</h3><p>Prueba con otros filtros</p>';
      grid.appendChild(emptyMsg);
    }
  } else {
    if (emptyMsg) emptyMsg.remove();
  }
}

function clearFilters(cards) {
  document.querySelectorAll('.collection-sidebar input[type="checkbox"]').forEach(cb => cb.checked = false);
  cards.forEach(card => card.style.display = '');

  const clearBtn = document.getElementById('btn-clear-filters');
  if (clearBtn) clearBtn.style.display = 'none';

  const emptyMsg = document.querySelector('.filter-empty-msg');
  if (emptyMsg) emptyMsg.remove();

  const resultsCount = document.querySelector('.results-count');
  if (resultsCount) {
    resultsCount.textContent = cards.length + ' producto' + (cards.length !== 1 ? 's' : '');
  }
}

// ========================================
// COLLECTION QUICK ADD
// ========================================

function initCollectionQuickAdd() {
  const quickAddButtons = document.querySelectorAll('.btn-quick-add');

  quickAddButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const productId = this.dataset.productId;
      if (!productId) return;

      const buttonText = this.innerHTML;
      this.disabled = true;
      this.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg> Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        this.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> ¡Agregado!';

        updateCartCount();

        setTimeout(() => {
          openCartDrawer();
          this.disabled = false;
          this.innerHTML = buttonText;
        }, 500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.disabled = false;
        this.innerHTML = buttonText;
      });
    });
  });
}

// ========================================
// PRODUCT QUANTITY
// ========================================

function initProductQuantity() {
  const qtyInput = document.querySelector('.qty-input');
  const qtyMinus = document.querySelector('.qty-minus');
  const qtyPlus = document.querySelector('.qty-plus');

  if (!qtyInput) return;

  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => {
      let value = parseInt(qtyInput.value) || 1;
      if (value > 1) {
        qtyInput.value = value - 1;
      }
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      let value = parseInt(qtyInput.value) || 1;
      let max = parseInt(qtyInput.max) || 99;
      if (value < max) {
        qtyInput.value = value + 1;
      }
    });
  }
}

// ========================================
// PRODUCT GALLERY
// ========================================

function initProductGallery() {
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mainImage = document.getElementById('main-product-image');

  if (!mainImage || thumbnails.length === 0) return;

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      // Remove active class from all
      thumbnails.forEach(t => t.classList.remove('active'));

      // Add active to clicked
      this.classList.add('active');

      // Change main image
      const newImageSrc = this.dataset.image;
      mainImage.src = newImageSrc;
    });
  });
}

// ========================================
// PRODUCT TABS
// ========================================

function initProductTabs() {
  const tabButtons = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');

  if (tabButtons.length === 0) return;

  tabButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const tabId = this.dataset.tab;

      // Remove active from all
      tabButtons.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));

      // Add active to clicked
      this.classList.add('active');
      document.getElementById(tabId).classList.add('active');
    });
  });
}

// ========================================
// SCROLL ANIMATIONS
// ========================================

function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('.animate-on-scroll, .animate-stagger');

  if (animatedElements.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Optionally unobserve after animation
        // observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  animatedElements.forEach(el => observer.observe(el));
}

// ========================================
// LAZY LOADING IMAGES
// ========================================

function initLazyLoading() {
  const lazyImages = document.querySelectorAll('img[data-src], img[loading="lazy"]');

  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;

          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }

          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }

          img.classList.add('is-loaded');
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '100px 0px'
    });

    lazyImages.forEach(img => {
      img.classList.add('lazy-image');
      imageObserver.observe(img);
    });
  } else {
    // Fallback for older browsers
    lazyImages.forEach(img => {
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.classList.add('is-loaded');
    });
  }
}

// ========================================
// PREDICTIVE SEARCH
// ========================================

function initPredictiveSearch() {
  const searchTriggers = document.querySelectorAll('[data-search-trigger]');
  const searchContainer = document.getElementById('predictive-search');
  const searchOverlay = document.getElementById('predictive-search-overlay');
  const searchInput = document.getElementById('predictive-search-input');
  const searchClose = document.getElementById('predictive-search-close');
  const searchClear = document.getElementById('predictive-search-clear');
  const searchResults = document.getElementById('predictive-search-results');
  const searchProducts = document.getElementById('predictive-search-products');
  const searchLoading = document.getElementById('predictive-search-loading');
  const searchEmpty = document.getElementById('predictive-search-empty');
  const searchViewAll = document.getElementById('predictive-search-view-all');

  if (!searchContainer || !searchInput) return;

  let searchTimeout;

  function openSearch() {
    const header = document.querySelector('.site-header');
    if (header && window.innerWidth >= 769) {
      const headerBottom = header.getBoundingClientRect().bottom;
      searchContainer.style.top = (headerBottom + 8) + 'px';
      document.body.style.overflow = '';
    } else {
      searchContainer.style.top = '';
      document.body.style.overflow = 'hidden';
    }
    searchContainer.classList.add('active');
    searchOverlay.classList.add('active');
    setTimeout(() => searchInput.focus(), 100);
  }

  function closeSearch() {
    searchContainer.classList.remove('active');
    searchOverlay.classList.remove('active');
    document.body.style.overflow = '';
    searchContainer.style.top = '';
    searchInput.value = '';
    clearResults();
  }

  function clearResults() {
    searchProducts.innerHTML = '';
    searchLoading.style.display = 'none';
    searchEmpty.style.display = 'none';
    searchViewAll.style.display = 'none';
    searchClear.style.display = 'none';
  }

  async function performSearch(query) {
    if (query.length < 2) {
      clearResults();
      return;
    }

    searchLoading.style.display = 'flex';
    searchEmpty.style.display = 'none';
    searchProducts.innerHTML = '';
    searchClear.style.display = 'flex';

    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
      const data = await response.json();

      searchLoading.style.display = 'none';

      const products = data.resources?.results?.products || [];

      if (products.length === 0) {
        searchEmpty.style.display = 'flex';
        searchViewAll.style.display = 'none';
        return;
      }

      searchProducts.innerHTML = `
        <div class="predictive-search-section">
          <div class="predictive-search-section-title">Productos (${products.length})</div>
          ${products.map(product => {
            const imgUrl = product.image ? product.image.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_80x80$1') : '';
            return `
            <a href="${product.url}" class="predictive-search-item">
              <div class="predictive-search-item-image">
                ${imgUrl ? `<img src="${imgUrl}" alt="${product.title}" loading="lazy">` : '<div class="predictive-search-no-img"></div>'}
              </div>
              <div class="predictive-search-item-info">
                <h4 class="predictive-search-item-title">${product.title}</h4>
                <div class="predictive-search-item-meta">
                  <span class="predictive-search-item-price">${formatMoney(product.price)}</span>
                </div>
              </div>
            </a>`;
          }).join('')}
        </div>
      `;

      searchViewAll.href = `/search?q=${encodeURIComponent(query)}`;
      searchViewAll.style.display = 'flex';

    } catch (error) {
      console.error('Search error:', error);
      searchLoading.style.display = 'none';
      searchEmpty.style.display = 'flex';
    }
  }

  // Event listeners
  searchTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openSearch();
    });
  });

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearch);
  }

  if (searchClear) {
    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.focus();
      clearResults();
    });
  }

  searchInput.addEventListener('input', (e) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      performSearch(e.target.value.trim());
    }, 300);
  });

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchContainer.classList.contains('active')) {
      closeSearch();
    }
  });
}

// ========================================
// TOAST NOTIFICATIONS
// ========================================

function showToast(message, type = 'default', duration = 3000) {
  let container = document.querySelector('.toast-container');

  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;
  toast.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      ${type === 'success' ? '<path d="M20 6L9 17l-5-5"/>' :
        type === 'error' ? '<circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6M9 9l6 6"/>' :
        '<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>'}
    </svg>
    <span>${message}</span>
  `;

  container.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('is-leaving');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

// ========================================
// BUTTON LOADING STATES
// ========================================

function setButtonLoading(button, isLoading) {
  if (isLoading) {
    button.classList.add('is-loading');
    button.disabled = true;
  } else {
    button.classList.remove('is-loading');
    button.disabled = false;
  }
}

// ========================================
// ENHANCED ADD TO CART
// ========================================

function enhancedAddToCart(variantId, quantity = 1, button = null) {
  if (button) setButtonLoading(button, true);

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(response => {
    if (!response.ok) throw new Error('Error adding to cart');
    return response.json();
  })
  .then(data => {
    showToast('Producto agregado al carrito', 'success');
    updateCartCount();
    openCartDrawer();
    return data;
  })
  .catch(error => {
    console.error('Add to cart error:', error);
    showToast('Error al agregar producto', 'error');
    throw error;
  })
  .finally(() => {
    if (button) setButtonLoading(button, false);
  });
}

// ========================================
// INITIALIZE NEW FEATURES
// ========================================

// Add to DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  initScrollAnimations();
  initLazyLoading();
  initPredictiveSearch();
  initSidebarCategoryAccordion();
});

function initSidebarCategoryAccordion() {
  document.querySelectorAll('.filter-category-parent').forEach(function(parent) {
    parent.addEventListener('click', function(e) {
      const group = parent.closest('.filter-category-group');
      if (!group) return;
      const hasChildren = group.querySelector('.filter-category-children');
      if (!hasChildren) return;
      e.preventDefault();
      group.classList.toggle('open');
    });
  });
}
